<template>
  <div class="tabs_content">
    <section v-if="entities">
      <div class="status search_only">
        <div class="field_left">
          <search-input
              v-if="!newPurchasedVideoOpen"
              input-class="search"
              v-model="formFields.search"
          />
          <h2 v-else v-translate>Přidat zakoupené TVOD video</h2>
        </div>
        <a
            v-if="$_updateActionAllowed"
            :title="'Přidat zakoupené video' | translate"
            :class="['add', 'add_expand', { open: newPurchasedVideoOpen }]"
            @click.prevent="toggleNewPurchasedVideo()"
            v-translate>Přidat zakoupené TVOD video
        </a>
      </div>
      <div :class="['filter', 'expand_content', { open: newPurchasedVideoOpen }]">
        <div class="field_left">
          <p>
            <select-box
                id="newVodVideo"
                :required="true"
                v-model="newVodVideo.id_video"
                :options="newPurchasedVideoOptions"
                @input="onVideoChange()"
                ref="newVodVideoref"
            >
              <translate class="translate">Video</translate>
            </select-box>
          </p>
          <p>
            <text-input
                id="newVodVideoPrice"
                :required="true"
                v-model="newVodVideo.price"
                ref="newVodVideoPriceref"
            >
              <translate class="translate">Cena</translate>
            </text-input>
          </p>
          <p>
            <select-box
                id="newVodVideoCurrency"
                :required="true"
                v-model="newVodVideo.id_currency"
                :options="newPurchasedVideoCurrenciesOptions"
                ref="newVodVideoCurrencyref"
            >
              <translate class="translate">Měna</translate>
            </select-box>
          </p>
          <p>
            <textarea-input
                id="newVodVideoNote"
                v-model="newVodVideo.note"
                ref="newVodVideoNoteref"
            >
              <translate class="translate">Poznámka</translate>
            </textarea-input>
          </p>
        </div>
        <div class="field_right field_btn">
          <p class="field">
            <input
                type="submit"
                class="btn"
                :value="'Uložit' | translate"
                @click.prevent.stop="addNewPurchasedVideo"
            />
          </p>
        </div>
      </div>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="subscribers-purchased-vod-videos">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <PurchasedVodVideosRow v-for="purchasedVodVideo in entities"
                                   :entity="purchasedVodVideo"
                                   :vod-detail-allowed="vodDetailAllowed"
                                   :key="purchasedVodVideo.id"
                                   ref="purchasedVodVideo_row"
                                   :selectedEntities="selectedEntities"
                                   @updatePurchasedVideo="onUpdatePurchasedVideo"
                                   @deletePurchasedVod="onDeletePurchasedVideo"
                                   @input="select" />
            <tr v-if="entities.length === 0">
              <td colspan="7" v-translate>Nebylo nalezeno žádné zakoupené TVOD video.</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-purchased-vod-videos"
          @select-all="toggleSelectAll"
          @run-multiple-action="executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import PurchasedVodVideosRow from "./PurchasedVodVideosRow.vue";
import listActions from "../../../mixins/list-actions";
import messages from "../../../mixins/message"

export default {
  name: "SubscriberDetailPurchasedVodVideos",
  components: { PurchasedVodVideosRow },
  mixins: [listActions, messages],
  props: {
    entity: Object,
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
      newPurchasedVideoOpen: false,
      vodList: {},
      currenciesList: {},
      defaultCurrencyId: null,
      newVodVideo: {
        id_video: null,
        price: null,
        id_currency: null,
        note: null,
      }
    }
  },
  created(SubscriberService) {
    this.entityService = SubscriberService

    this.getEntities()
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sName' },
        { id: 2, name: this.$gettext('Cena') },
        { id: 3, name: this.$gettext('Zařízení') },
        { id: 4, name: this.$gettext('Profil') },
        { id: 5, name: this.$gettext('Typ zakoupení') },
        { id: 6, name: this.$gettext('Poznámka') },
        { id: 7, name: this.$gettext('Čas zakoupení'), column: 'sPurchaseTimestamp' },
      ]
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
      ];
    },
    newPurchasedVideoOptions() {
      return Object.values(this.vodList);
    },
    newPurchasedVideoCurrenciesOptions() {
      return Object.values(this.currenciesList);
    },
    vodDetailAllowed() {
      return this.$_loggedUser_action_allowed('vod', 'read');
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'price': { name: this.$gettext('Cena') },
        'device_name': { name: this.$gettext('Zařízení') },
        'subscriber_profile_name': { name: this.$gettext('Profil') },
        'purchase_timestamp': {
          name: this.$gettext('Datum zakoupení'), callback: (entity) => {
            return entity.purchase_timestamp ? this.$_datetime_format(entity.purchase_timestamp) : ''
          }
        }
      }
    },
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.entityService.getSubscriberPurchasedVodVideos(this.entity.id, params).then((data) => {
        this.entities = data['purchased_vod_videos']
        this.totalCount = data['totalCount']
      })
    },
    getVideos() {
      this.entityService.getVodVideosToBuy(this.$route.params.id)
          .then((data) => {
            this.vodList = data['videos'];
            this.defaultCurrencyId = data['default_id_currency'];
            this.currenciesList = data['currencies'];
            this.resetNewVodVideo();
          });
    },
    toggleNewPurchasedVideo() {
      this.newPurchasedVideoOpen = !this.newPurchasedVideoOpen
      if (this.newPurchasedVideoOpen) {
        this.getVideos();
      }
    },
    onVideoChange() {
      if (this.newVodVideo.id_video) {
        this.newVodVideo.price = this.vodList[this.newVodVideo.id_video].price;
      } else {
        this.newVodVideo.price = null;
      }
      this.newVodVideo.id_currency = this.defaultCurrencyId;
    },
    addNewPurchasedVideo() {
      this.entityService.addSubscriberPurchasedVodVideo(this.$route.params.id, this.newVodVideo)
          .then(() => {
            this.$emit('changedVideo');
            this.setSuccessMessage();
            this.newPurchasedVideoOpen = false;
            this.resetNewVodVideo();
          })
          .catch(error => {
            this.setErrorMessage(error['error_message']);
            this.setInvalid(this.newVodVideo);
          });
    },
    onUpdatePurchasedVideo(data) {
      this.entityService.updateSubscriberPurchasedVodVideo(this.$route.params.id, data)
          .then(() => {
            this.$emit('changedVideo');
            this.setSuccessMessage();
          })
          .catch(error => {
            this.setErrorMessage(error['error_message']);
          });
    },
    onDeletePurchasedVideo(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteVideo');
      } else {
        this.entityService.deleteSubscriberPurchasedVodVideo(this.entity.id, {id_video: id})
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
              this.$refs['purchasedVodVideosRed'].getVideos();
            })
            .catch(function (error) {
              this.getEntities();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    resetNewVodVideo() {
      this.newVodVideo = {
        id_video: null,
        price: null,
        id_currency: null,
        note: null,
      };
      this.$refs['newVodVideoref'].setTouched(false);
      this.$refs['newVodVideoref'].setForcedInvalid(false);
      this.$refs['newVodVideoPriceref'].setForcedInvalid(false);
      this.$refs['newVodVideoCurrencyref'].setForcedInvalid(false);
    },
    setInvalid(data) {
      if (!data.id_video) {
        this.$refs['newVodVideoref'].setForcedInvalid(true);
      }
      if (data.price === null || data.price === '') {
        this.$refs['newVodVideoPriceref'].setForcedInvalid(true);
      }
      if (!data.id_currency) {
        this.$refs['newVodVideoCurrencyref'].setForcedInvalid(true);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.entityService.getSubscriberPurchasedVodVideos(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['purchased_vod_videos']);
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/purchasedVodVideos/PurchasedVodVideos.vue